export enum NotificationTypeEnum {
  Success = 1,
  Error = 2,
  Warning = 3
}
